import type { PropType } from 'vue'

export const makeStringProp = <T>(defaultVal: T) => ({
  type: String as unknown as PropType<T>,
  default: defaultVal
})

export function closest(arr: number[], target: number) {
  return arr.reduce((pre, cur) => (Math.abs(pre - target) < Math.abs(cur - target) ? pre : cur))
}

export function addUnit(value?: string | number): string | undefined {
  if (value !== undefined && value !== null) {
    return typeof value === 'number' || /^\d+(\.\d+)?$/.test(String(value))
      ? `${value}px`
      : String(value)
  }
  return undefined
}

export function pick<T, U extends keyof T>(
  obj: T,
  keys: ReadonlyArray<U>,
  ignoreUndefined?: boolean
): Pick<T, U> {
  return keys.reduce(
    (ret, key) => {
      if (!ignoreUndefined || obj[key] !== undefined) {
        ret[key] = obj[key]
      }
      return ret
    },
    {} as Pick<T, U>
  )
}
